import { authedFetch } from '../utils/backendFetch.js';

/**
 * Ask the backend to read one public page and suggest profile values.
 * Resolves to the suggestion payload; rejects with an Error whose `code` is
 * 'page_unreadable' when the page couldn't be read (login walls, blocked sites).
 */
const FALLBACK_MESSAGE = 'Could not auto-fill right now. Please try again.';

export async function requestProfilePrefill(url, options) {
  let response;
  try {
    response = await authedFetch(`${process.env.REACT_APP_MAIN_BACKEND_URL}/scribe/profile-prefill`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ url, options }),
    });
  } catch (err) {
    // fetch() rejects with a bare TypeError ("Failed to fetch") when the backend
    // can't be reached; never show that raw text. authedFetch's own
    // session-expired Error is already user-facing, so it passes through.
    if (err instanceof TypeError) {
      const error = new Error(FALLBACK_MESSAGE);
      error.code = 'network';
      throw error;
    }
    throw err;
  }
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.error || FALLBACK_MESSAGE);
    error.code = data.code || (response.status === 400 ? 'bad_url' : 'failed');
    throw error;
  }
  return data;
}
